import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NavController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { RolUsuario } from '../_models/_enums/rolUsuario.enum';

export interface AuthRequest {
  correo: string;
  clave: string;
}

export interface AuthRequest2FA {
  correo: string;
  clave: string;
  codigo: string;
  dobleFactor: boolean;
}

export interface DatosRestablecer {
  usuario: string;
  correo: string;
}

export interface DatosUsuario {
  id: number;
  usuario: string;
  nombreCompleto: string;
  correo: string;
  token: string;
  rol: RolUsuario;
  idProveedor?: number;
  idAsociado?: number; // IdCliente
}

@Injectable({
  providedIn: 'root',
})
export class AutentificacionService {
  private apiUrl = `${environment.apiUrl}/Usuario`;

  private currentUserSubject: BehaviorSubject<DatosUsuario | null> =
    new BehaviorSubject<DatosUsuario | null>(null);
  public currentUser: Observable<DatosUsuario | null>;

  constructor(
    public navCtrl: NavController,
    private http: HttpClient,
  ) {
    if (localStorage.getItem('currentUser')) {
      this.currentUserSubject = new BehaviorSubject<DatosUsuario | null>(
        JSON.parse(localStorage.getItem('currentUser')!),
      );
    }
    this.currentUser = this.currentUserSubject.asObservable();
  }

  private setUserValue(datosUsuario: DatosUsuario) {
    this.currentUserSubject.next(datosUsuario);
  }

  public get userInfo(): DatosUsuario | null {
    return this.currentUserSubject.value;
  }

  public isAuthenticated(): boolean {
    if (localStorage.getItem('currentUser')) {
      return true;
    }
    return false;
  }

  login(correo: string, clave: string, recordar: boolean = false) {
    const loginData: AuthRequest = {
      correo,
      clave,
    };

    return this.http.post<DatosUsuario>(`${this.apiUrl}/login`, loginData).pipe(
      map((data) => {
        if (data && data.token) {
          this.setUserValue(data);
          if (recordar == true) {
            localStorage.setItem('currentUser', JSON.stringify(data));
          } else {
            sessionStorage.setItem('currentUser', JSON.stringify(data));
          }
        }
        return data;
      }),
    );
  }

  loginDobleFactor(
    correo: string,
    clave: string,
    codigo: string,   
    dobleFactor: boolean = false,
  ) {
    const loginData: AuthRequest2FA = {
      correo,
      codigo,
      clave,
      dobleFactor,
    };

    return this.http.post<DatosUsuario>(`${this.apiUrl}/login`, loginData).pipe(
      map((data) => {
        if (data && data.token) {
          this.setUserValue(data);     
        }
        return data;
      }),
    );
  }

  logout() {
    //Borrar los datos del current user de local y session
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    //Redirigir a la pagina de login
    this.navCtrl.navigateRoot(['login']);
  }

  restablecerContraseña(datosUsuario: {
    usuario: string;
    correo: string;
  }): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/solicitar-restablecer-contrasena`,
      datosUsuario,
    );
  }

  // Restablecer contraseña desde el inicio de sesión
  solicitarRestablecerContrasenaUsuario(
    correo: string,
    nombreUsuario?: string,
  ): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/solicitar-restablecer-contrasena`,
      { usuario: nombreUsuario, correo: correo },
      { responseType: 'text' },
    );
  }
  // Restablecer contraseña desde dentro del panel
  solicitarRestablecerContrasena(idUsuario: number): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/${idUsuario}/restablecer-contrasena`,
      null,
    );
  }

  enviarCorreoBienvenida(idUsuario: number) {
    return this.http.put(
      `${this.apiUrl}/enviar-correo-bienvenida/${idUsuario}`,
      {},
    );
  }

  enviarCodigoInicioFA(correoUsuario: string) {
    return this.http.post(
      `${this.apiUrl}/generar-token-doble-factor`,
      { correo: correoUsuario },
      { responseType: 'text' },
    );
  }

  obtenerDobleFactorValidacion(correo: string, clave: string) {
    return this.http.post<boolean>(`${this.apiUrl}/obtener-dobleFactor-usuario`, {
      correo: correo,
      clave: clave
    });
  }
}
